import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Hero from "@/components/Hero";
import FeatureShowcase from "@/components/landing/FeatureShowcase";
import About from "@/components/About";
import Comparison from "@/components/landing/Comparison";
import SignupForm from "@/components/landing/SignupForm";
import { Loader2 } from "lucide-react";

const Home = () => {
  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    console.log('[Home] Componente montado');
    setIsReady(true);
    return () => console.log('[Home] Componente desmontado');
  }, []);

  if (!isReady) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  console.log('[Home] Renderizando página completa');

  return (
    <div className="min-h-screen bg-background">
      <Hero />
      <FeatureShowcase />
      <About />
      <Comparison />
      <SignupForm />
      
      {/* Footer Minimalista */}
      <footer className="py-12 px-6 border-t border-border bg-card">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-2">
              <p className="text-sm text-muted-foreground">
                Feito com 💜 para mentes criativas
              </p>
            </div>
            <div className="flex gap-6 text-sm text-muted-foreground">
              <button 
                onClick={() => {
                  console.log('[Home] Navegando para /install');
                  navigate('/install');
                }}
                className="hover:text-foreground transition-colors"
              >
                Instalar App
              </button>
              <button className="hover:text-foreground transition-colors">
                Privacidade
              </button>
              <button className="hover:text-foreground transition-colors">
                Termos
              </button>
              <button className="hover:text-foreground transition-colors">
                Contato
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
